export default __webpack_public_path__ + "static/media/dot_decentralized.e546c04f.svg";